import React, { Component } from 'react'
import style from './style.css'
import FaHome from 'react-icons/lib/fa/home'
import FaSearch from 'react-icons/lib/fa/search'
import { Link } from 'react-router-dom';

class TopLinks extends Component {

    render() {
        return (
            <div className={ `${style.topLinks} ${style.btline} container` }>
                <div className={ `no-padding ${ style.row }`}>
                    <div className={ style.col4 }>
                        <FaHome className={style.iconHome}/>
                        <Link to={`/aboutus`} className={style.links} >About us</Link>
                        <Link to={`/contactus`} className={style.links}>Contact us</Link>
                    </div>
                    <div className={ style.col3 }>
                        &nbsp;
                    </div>
                    <div className={ style.col5 }>
                        <FaSearch className={ style.iconSearch} />
                        <Link to={`/contactus`} className={ style.links } >Sign in</Link>
                        <Link to={`/contactus`} className={ style.links } >English</Link>
                        <a href="#" className={ style.makeAReservation }>Book Your Stay</a>
                    </div>
                </div>
            </div>
        )
    }
}

export default TopLinks



// WEBPACK FOOTER //
// ./src/components/largeheader/top_links.js